import { RiskTag } from '@/components/chariot-ui';
import { RiskSeverity, SeverityOpenCounts } from '@/types';

export interface VulnerabilitySummaryProps {
  riskCounts: SeverityOpenCounts | undefined;
}

export function VulnerabilitySummary({
  riskCounts,
}: VulnerabilitySummaryProps) {
  return (
    <div className="flex w-full items-center justify-between gap-3">
      <div className="flex flex-col justify-between gap-3">
        <p className="text-lg font-bold">Open Vulnerabilities</p>
        <div className="flex w-full justify-between gap-2">
          <RiskTag
            severity="critical"
            prefix={(riskCounts?.[RiskSeverity.Critical] ?? 0).toString()}
            size="sm"
          />
          <RiskTag
            severity="high"
            prefix={(riskCounts?.[RiskSeverity.High] ?? 0).toString()}
            size="sm"
          />
          <RiskTag
            severity="medium"
            prefix={(riskCounts?.[RiskSeverity.Medium] ?? 0).toString()}
            size="sm"
          />
          <RiskTag
            severity="low"
            prefix={(riskCounts?.[RiskSeverity.Low] ?? 0).toString()}
            size="sm"
          />
          <RiskTag
            severity="info"
            prefix={(riskCounts?.[RiskSeverity.Info] ?? 0).toString()}
            size="sm"
          />
          <RiskTag
            severity="exposure"
            prefix={(riskCounts?.[RiskSeverity.Exposure] ?? 0).toString()}
            size="sm"
          />
        </div>
      </div>
    </div>
  );
}
